import { ASIACHANGETRIP, ASIAADDADULT, ASIAMINUSADULT, ASIAADDCHILDREN, ASIAMINUSCHILDREN, ASIAPICKDATE, ASIAADDTOCART, ASIAREMOVEFROMCART, ASIAAIRPORTPICKUP, ASIADIFFERENTHOTEL, ASIAMORETRIPS, ASIAREMOVEALL } from "./AsiaTypes";

export function asiaChangeTrip(id, e) {
  return { type: ASIACHANGETRIP, payload: id, data: e.target.value };
}

export function asiaAddAdult(id, e) {
  e.preventDefault()
  return { type: ASIAADDADULT, payload: id };
}

export function asiaMinusAdult(id, e) {
  e.preventDefault()
  return { type: ASIAMINUSADULT, payload: id };
}

export function asiaAddChildren(id, e) {
  e.preventDefault()
  return { type: ASIAADDCHILDREN, payload: id };
}

export function asiaMinusChildren(id, e) {
  e.preventDefault()
  return { type: ASIAMINUSCHILDREN, payload: id };
}

export function asiaPickDate(id, e) {
  return { type: ASIAPICKDATE, payload: id, data: e.target.value };
}

export function asiaAddToCart(id, e) {
  e.preventDefault()
  return { type: ASIAADDTOCART, payload: id, data: e.target.value };
}

export function asiaRemoveFromCart(id, e) {
  e.preventDefault()
  return { type: ASIAREMOVEFROMCART, payload: id, data: e.target.value };
}

export function asiaAirportPickUp(id, e) {
  return {type: ASIAAIRPORTPICKUP, payload: id, data: e.target.value}
}

export function asiaDifferentHotel(id, e){
  return {type: ASIADIFFERENTHOTEL, payload: id, data: e.target.value}
}

export function asiaMoreTrips(id, e){
  return {type: ASIAMORETRIPS, payload:id, data:e.target.value}
}

export function asiaRemoveAll(){
  return {type: ASIAREMOVEALL}
}